import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const ridersOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.RIDERS,
    steps: [
        {
            id: "rdr-welcome",
            title: "Gestão de Passageiros",
            description:
                "Aqui você visualiza e gerencia todos os passageiros cadastrados na plataforma.",
            position: "center",
        },
        {
            id: "rdr-table",
            title: "Lista de Passageiros",
            description:
                "A tabela mostra nome, telefone, data de cadastro e status. Clique em uma linha para ver mais detalhes.",
            targetId: "riders-table",
            position: "bottom",
        },
        {
            id: "rdr-search",
            title: "Busca Rápida",
            description:
                "Encontre passageiros por nome ou número de telefone usando o campo de busca.",
            targetId: "riders-search",
            position: "bottom",
        },
        {
            id: "rdr-details",
            title: "Detalhes do Passageiro",
            description:
                "Ao selecionar um passageiro, veja o histórico de corridas, avaliações e dados de perfil.",
            targetId: "riders-actions",
            position: "left",
        },
    ],
};
